const riskStatusBadge = (status) => {
  const colors = {
    HIGH_RISK: "bg-[#DC2626] text-white",
    MODERATE_RISK: "bg-[#FF7439] text-white",
    LOW_RISK: "bg-[#FFEE33] text-[#374151]",
    NO_RISK: "bg-[#B7E049] text-[#374151]",
    NA: "bg-[#B2BEB5] text-[#374151]",
  };

  // Extract only the first word before "_RISK" and format it
let label;
  if (status === "NA") {
    label = "NA";
  } else if (status === "NO_RISK") {
    label = "No Risk"; // Special case
  } else if (status) {
    label = status
      .split("_")[0]
      .toLowerCase()
      .replace(/\b\w/g, (c) => c.toUpperCase());
  } else {
    label = "N/A";
  }
  const badgeClass = colors[status] || "bg-[#F1F5F9] text-[#334155]";

  return (
    <span className={`inline-block rounded-full px-2.5 py-0.5 text-[11px] font-semibold font-poppins ${badgeClass}`}>
      {label}
    </span>
  );
};


const statusBadge = (status) => {
  const colors = {
    ACTIVE: "bg-[#ECFDF5] text-[#059669]",
    INACTIVE: "bg-[#F1F5F9] text-[#64748B]",
  };

  return (
    <span className={`inline-block rounded-full px-2.5 py-0.5 text-[11px] font-semibold font-poppins ${colors[status] || "bg-[#F1F5F9] text-[#334155]"}`}>
      {status}
    </span>
  );
};

export { riskStatusBadge, statusBadge };
